import React, { useRef, useState, useEffect } from 'react';
import { Menu } from 'primereact/menu';
import { useNavigate } from 'react-router-dom';

const Navbar: React.FC = () => {
    const menu = useRef<Menu>(null);
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);

    // Obtener datos del empleado loggeado (igual que en sidebar)
    const nombreEmpleado = localStorage.getItem('nombreEmpleado') || 'Empleado';
    const cveEmpleado = localStorage.getItem('cveEmpleado') || '';

    // Detectar dispositivos móviles
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Función que se ejecuta al hacer clic en "Cerrar sesión" (actualizada para empleados)
    const handleLogout = () => {
        console.log("Cerrando sesión de empleado...");

        // 🧹 Limpiar datos del localStorage (tokens de empleados)
        localStorage.removeItem('authToken2');
        localStorage.removeItem('cveEmpleado');
        localStorage.removeItem('nombreEmpleado');

        // 🚪 Redirigir al login de empleados
        navigate('/login-empleados');
    };

    // Función para navegar a inicio de empleados
    const handleGoHome = () => {
        navigate('/empinicio');
    };

    // Función para ir a peticiones
    const handleGoPeticiones = () => {
        navigate('/peticiones');
    };

    // Función para cambiar contraseña
    const handleChangePassword = () => {
        navigate('/empleados');
    };

    // Menú desplegable actualizado
    const items = [
        {
            label: 'Navegación',
            icon: 'pi pi-compass',
            items: [
                
                {
                    label: 'Cambiar Contraseña',
                    icon: 'pi pi-key',
                    command: handleChangePassword,
                },
            ],
        },
        {
            separator: true
        },
        {
            
            label: 'Cuenta',
            icon: 'pi pi-user',
            items: [
                {
                    label: 'Cerrar Sesión',
                    icon: 'pi pi-sign-out',
                    command: handleLogout,
                },
            ],
        },
    ];

    return (
        <>
            {/* Estilos CSS para la navbar */}
            <style>
                {`
                    /* Asegurar que la navbar se ajuste al sidebar */
                    .main-header.navbar {
                        margin-left: var(--sidebar-width, 60px) !important;
                        width: calc(100% - var(--sidebar-width, 60px)) !important;
                        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
                        z-index: 999;
                        background: linear-gradient(90deg, #ffffff 0%, #f8fafc 100%) !important;
                        border-bottom: 2px solid #e2e8f0 !important;
                        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;
                    }

                    /* Estilos para el botón de usuario */
                    .user-info-button {
                        display: flex !important;
                        align-items: center !important;
                        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%) !important;
                        border: none !important;
                        border-radius: 25px !important;
                        padding: 8px 16px !important;
                        color: white !important;
                        font-weight: 600 !important;
                        transition: all 0.3s ease !important;
                        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
                        cursor: pointer !important;
                    }

                    .user-info-button:hover {
                        transform: translateY(-2px) !important;
                        box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4) !important;
                        background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%) !important;
                    }

                    .user-info-button:active {
                        transform: translateY(0) !important;
                    }

                    /* Estilos para enlaces de navegación */
                    .nav-link-custom {
                        color: #374151 !important;
                        font-weight: 600 !important;
                        transition: all 0.3s ease !important;
                        border-radius: 8px !important;
                        padding: 8px 16px !important;
                        margin: 0 4px !important;
                    }

                    .nav-link-custom:hover {
                        background: rgba(59, 130, 246, 0.1) !important;
                        color: #3b82f6 !important;
                        transform: translateY(-1px) !important;
                    }

                    /* Botones de acción */
                    .action-button {
                        background: transparent !important;
                        border: 2px solid #e5e7eb !important;
                        border-radius: 8px !important;
                        padding: 8px 12px !important;
                        color: #6b7280 !important;
                        transition: all 0.3s ease !important;
                        margin: 0 4px !important;
                    }

                    .action-button:hover {
                        border-color: #3b82f6 !important;
                        color: #3b82f6 !important;
                        background: rgba(59, 130, 246, 0.05) !important;
                        transform: translateY(-1px) !important;
                    }

                    /* Portal info badge */
                    .portal-badge {
                        background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
                        color: white !important;
                        padding: 4px 12px !important;
                        border-radius: 20px !important;
                        font-size: 0.75rem !important;
                        font-weight: 600 !important;
                        margin-right: 12px !important;
                        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3) !important;
                    }

                    /* Responsividad */
                    @media (max-width: 768px) {
                        .main-header.navbar {
                            margin-left: 0 !important;
                            width: 100% !important;
                        }
                        
                        .d-none.d-sm-inline-block {
                            display: none !important;
                        }
                        
                        .portal-badge {
                            display: none !important;
                        }
                        
                        .user-info-button {
                            padding: 6px 12px !important;
                            font-size: 0.85rem !important;
                        }
                    }

                    /* Animaciones */
                    @keyframes fadeInDown {
                        from {
                            opacity: 0;
                            transform: translateY(-10px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    .navbar-brand-text {
                        animation: fadeInDown 0.6s ease-out;
                    }
                `}
            </style>

            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                {/* Left navbar links */}
                <ul className="navbar-nav">
                    
                    <li className="nav-item d-none d-sm-inline-block">
                        <a
                            href="#"
                            className="nav-link nav-link-custom"
                            onClick={(e) => {
                                e.preventDefault();
                                handleGoHome();
                            }}
                        >
                            🏠 Inicio
                        </a>
                    </li>
                    <li className="nav-item d-none d-sm-inline-block">
                        <a
                            href="#"
                            className="nav-link nav-link-custom"
                            onClick={(e) => {
                                e.preventDefault();
                                handleGoPeticiones();
                            }}
                        >
                            📋 Nueva Petición
                        </a>
                    </li>
                   
                </ul>

                
               

                {/* Right navbar links */}
                <ul className="navbar-nav ml-auto">
                    {/* Botón de usuario y menú desplegable */}
                    <li className="nav-item">
                        <Menu model={items} popup ref={menu} id="menu" />
                        <button
                            className="user-info-button"
                            onClick={(e) => menu.current?.toggle(e)}
                            title={`${nombreEmpleado} (ID: ${cveEmpleado})`}
                        >
                            <i className="pi pi-user" style={{ marginRight: isMobile ? '0' : '8px' }} />
                            {!isMobile && (
                                <span className="navbar-brand-text">
                                    {nombreEmpleado.length > 100 ? `${nombreEmpleado.substring(0, 15)}...` : nombreEmpleado}
                                </span>
                            )}
                            <i className="pi pi-chevron-down" style={{ 
                                marginLeft: isMobile ? '0' : '8px',
                                fontSize: '0.8rem'
                            }} />
                        </button>
                    </li>
                </ul>
            </nav>
        </>
    );
};

export default Navbar;